import _ from "lodash"

export default function handleSubmitValues(values) {
  const fieldConditionalValue = () => {
    if (!values.field_conditional) return ""
    const { field_conditional_key, field_conditional_value } = values
    const conditionalObj = {
      [field_conditional_key]: field_conditional_value,
    }
    return JSON.stringify(conditionalObj)
  }

  const fieldTypeValue = () => {
    if (!values.field_conditional) return values.field_type
    return `conditional_${values.field_type}`
  }

  const fieldValidationValue = () => {
    let validationObj = {}

    if (!values.field_required) {
      validationObj = {
        required: [false, ""],
      }
    } else {
      validationObj = {
        required: [values.field_required, values.field_required_msg],
      }
    }

    if (values.field_type === "number") {
      validationObj = {
        ...validationObj,
        number_min: values.field_number_min,
        number_max: values.field_number_max,
      }
    }

    return JSON.stringify(validationObj)
  }

  const fieldTypeOptions = () => {
    const listOfOptions = _.map(values.field_options, (option) => {
      return { label: option, value: option }
    })
    return JSON.stringify(listOfOptions)
  }

  const newField = {
    field_name: values.field_name,
    field_name_report: values.field_name_report,
    description: values.description,
    field_conditional: fieldConditionalValue(),
    field_description: values.field_description,
    field_label: values.field_label,
    field_type: fieldTypeValue(),
    field_type_subtype: values.field_type_subtype,
    field_options: fieldTypeOptions(),
    field_validation: fieldValidationValue(),
    field_visibility: true,
  }

  return {
    ...newField,
  }
}
